module.exports = __webpack_public_path__ + "img/franchising_help_marketing2.20323b14.png";